module.exports = __webpack_public_path__ + "img/t1.e9564389.png";